import {createBrowserRouter} from "react-router-dom";
import ErrorPage from "./pages/ErrorPage";
import Layout from "./components/Layout";
import React from "react";
import EventsPage from "./pages/EventsPage";
import LoginSignupPage from "./pages/LoginSignupPage";
import ForgotPasswordPage from "./pages/ForgotPasswordPage";
import PasswordResetPage from "./pages/PasswordResetPage";
import SignupPage from "./pages/SignupPage";
import AccountPage from "./pages/AccountPage";
import EventPage from "./pages/EventPage";
import EventBookingProductsPage from "./pages/EventBookingProductsPage";
import BookingSuccessfulPage from "./pages/BookingSuccessfulPage";
import CheckoutPage from "./pages/CheckoutPage";
import PaypalPaymentCancelledPage from "./pages/PaypalPaymentCancelledPage";
import PaypalPaymentConfirmationPage from "./pages/PaypalPaymentConfirmationPage";
import StripePaymentConfirmationPage from "./pages/StripePaymentConfirmationPage";
import StripePaymentCancelledPage from "./pages/StripePaymentCancelledPage";
import MolliePaymentCallbackPage from "./pages/MolliePaymentCallbackPage";
import ShopPage from "./pages/ShopPage";
import ShopItemPage from "./pages/ShopItemPage";
import CartPage from "./pages/CartPage";
import ShopCheckoutPage from "./pages/ShopCheckoutPage";
import ShopPaypalConfirmationPage from "./pages/ShopPaypalConfirmationPage";
import ShopPaypalCancelledPage from "./pages/ShopPaypalCancelledPage";
import ShopStripeConfirmationPage from "./pages/ShopStripeConfirmationPage";
import ShopStripeCancelledPage from "./pages/ShopStripeCancelledPage";
import ShopMollieCallbackPage from "./pages/ShopMollieCallbackPage";
import ShopRouteGuard from "./components/ShopRouteGuard";
import WithdrawalPage from "./pages/WithdrawalPage";

const router = createBrowserRouter([
    {
        path         : "/",
        element      : <Layout/>,
        errorElement : <ErrorPage/>,
        children     : [
            {
                path    : "/",
                element : <EventsPage/>,
            },
            {
                path    : "/login",
                element : <LoginSignupPage/>,
            },
            {
                path    : "/forgot-password",
                element : <ForgotPasswordPage/>,
            },
            {
                path    : "/password-reset",
                element : <PasswordResetPage/>,
            },
            {
                path    : "/signup",
                element : <SignupPage/>,
            },
            {
                path    : "/vertrag-widerrufen",
                element : <WithdrawalPage/>,
            },
            {
                path    : "/account",
                element : <AccountPage/>,
            },
            {
                path    : "/events/:eventUuid",
                element : <EventPage/>,
            },
            {
                path    : "/events/:eventUuid/booking-products",
                element : <EventBookingProductsPage/>,
            },
            {
                path    : "/bookings/:bookingUuid/successful",
                element : <BookingSuccessfulPage/>,
            },
            {
                path    : "/events/:eventUuid/products/:productUuid/checkout",
                element : <CheckoutPage/>,
            },
            {
                path    : "/paypal/cancelled",
                element : <PaypalPaymentCancelledPage/>
            },
            {
                path    : '/paypal/confirmation',
                element : <PaypalPaymentConfirmationPage/>
            },
            {
                path    : '/stripe/confirmation',
                element : <StripePaymentConfirmationPage/>
            },
            {
                path    : '/stripe/cancelled',
                element : <StripePaymentCancelledPage/>
            },
            {
                path    : '/mollie/callback',
                element : <MolliePaymentCallbackPage/>
            },
            {
                path    : "/shop",
                element : <ShopRouteGuard><ShopPage/></ShopRouteGuard>,
            },
            {
                path    : "/shop/items/:itemUuid",
                element : <ShopRouteGuard><ShopItemPage/></ShopRouteGuard>,
            },
            {
                path    : "/cart",
                element : <ShopRouteGuard><CartPage/></ShopRouteGuard>,
            },
            {
                path    : "/cart/checkout",
                element : <ShopRouteGuard><ShopCheckoutPage/></ShopRouteGuard>,
            },
            {
                path    : "/shop/paypal/confirmation",
                element : <ShopRouteGuard><ShopPaypalConfirmationPage/></ShopRouteGuard>
            },
            {
                path    : "/shop/paypal/cancelled",
                element : <ShopRouteGuard><ShopPaypalCancelledPage/></ShopRouteGuard>
            },
            {
                path    : "/shop/stripe/confirmation",
                element : <ShopRouteGuard><ShopStripeConfirmationPage/></ShopRouteGuard>
            },
            {
                path    : "/shop/stripe/cancelled",
                element : <ShopRouteGuard><ShopStripeCancelledPage/></ShopRouteGuard>
            },
            {
                path    : "/shop/mollie/callback",
                element : <ShopRouteGuard><ShopMollieCallbackPage/></ShopRouteGuard>
            }
        ],
    },
    {
        path    : '*',
        element : <div>404 - Page Not Found</div>
    }
]);

export default router;